module.exports = __webpack_public_path__ + "static/site-1784739815621/img/logo_visa.5f04499f.svg";